import { feature } from 'topojson-client';
import type { FeatureCollection, MultiPolygon, Polygon } from 'geojson';
import type { Topology, GeometryCollection } from 'topojson-specification';
import worldTopo from './world.topojson.json';

const topology = worldTopo as unknown as Topology;
const countriesObj = topology.objects.countries as GeometryCollection;

// 国家多边形数据，属性包含 id（ISO_N3）、isoA3 和英文名称。
// 填色与国界共用这一份多边形，保证两者完全贴合。
export const countryCollection = feature(topology, countriesObj) as unknown as FeatureCollection<Polygon | MultiPolygon>;
